import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/concept', label: 'コンセプト' },
    { path: '/menu', label: 'メニュー' },
    { path: '/gallery', label: 'ギャラリー' },
    { path: '/voice', label: 'お客様の声' },
    { path: '/access', label: 'アクセス' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/223210cca3eea8c93a672cef2c69acc0.png"
              alt="さかなの木 ロゴ"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-accent ${
                  location.pathname === link.path ? 'text-accent' : 'text-brand'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:03-6715-0369"
              className="flex items-center gap-2 px-5 py-2.5 bg-brand text-white rounded-full text-sm font-medium hover:bg-brand/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              <span>電話予約</span>
            </a>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-5 py-2.5 bg-[#06C755] text-white rounded-full text-sm font-medium hover:bg-[#06C755]/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill"></i>
              <span>LINE予約</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-brand cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-2 text-sm font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-accent bg-accent/5'
                      : 'text-brand hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col gap-2 px-4 pt-3 border-t border-gray-200">
                <a
                  href="tel:03-6715-0369"
                  className="flex items-center justify-center gap-2 px-5 py-2.5 bg-brand text-white rounded-full text-sm font-medium hover:bg-brand/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  <span>電話予約</span>
                </a>
                <a
                  href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 px-5 py-2.5 bg-[#06C755] text-white rounded-full text-sm font-medium hover:bg-[#06C755]/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-line-fill"></i>
                  <span>LINE予約</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
